import { COUNTRY_LIST, IS_PRIVACY_POLICY } from '../constants';

export const personalInfoFormErrorMapping = {
    firstName: 'firstNameLabel',
    lastName: 'lastNameLabel',
    dateOfBirth: 'dateOfBirthLabel',
    mobileNumber: 'mobileNumberLabel',
    password: 'passwordFieldLabel'
};

export const accountInfoFormErrorMapping = countryCode => {
    const mapping = {
        country: 'countryLabel',
        address: 'addressLabel',
        city: 'cityLabel'
    };
    if (countryCode === COUNTRY_LIST[1].value) {
        mapping.state = 'provinceLabel';
        mapping.zipCode = 'postalLabel';
    } else {
        mapping.state = 'stateLabel';
        mapping.zipCode = 'zipcodeLabel';
        mapping.driversLicenseState = 'driversLicenseStateLabel';
        mapping.driversLicenseNumber = 'driversLicenseNumberLabel';
    }
    return mapping;
};

export const formErrorFields = (error, fieldLabel, formErrorMappingField, privacyPolicyLabel) => {
    if (!error) {
        return [];
    }

    const mapErrorToLabel = field => {
        if (field === IS_PRIVACY_POLICY) {
            return privacyPolicyLabel;
        } else {
            return fieldLabel[formErrorMappingField[field]];
        }
    };

    const fieldsWithErrors = Object.keys(error).filter(field => error[field]);
    return fieldsWithErrors.map(mapErrorToLabel).filter(constructedError => !!constructedError);
};
